var map = {
	"./OrderSuccess/locales/zh-CN.json": 915,
	"./PersonalCentre/locales/zh-CN.json": 916,
	"./cart/locales/zh-CN.json": 917,
	"./checkout/locales/zh-CN.json": 918,
	"./collection/locales/zh-CN.json": 919,
	"./common/locales/zh-CN.json": 920,
	"./forgottenPassword/locales/zh-CN.json": 921,
	"./layouts/locales/zh-CN.json": 922,
	"./pages/locales/zh-CN.json": 923,
	"./products/locales/zh-CN.json": 924,
	"./register/locales/zh-CN.json": 925
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 914;